module.exports = __webpack_public_path__ + "img/uac-engineering-logo.0b75e15d.jpg";